import { render, staticRenderFns } from "./devoirsDashParent.vue?vue&type=template&id=2c9fc31a&"
import script from "./devoirsDashParent.vue?vue&type=script&lang=js&"
export * from "./devoirsDashParent.vue?vue&type=script&lang=js&"
import style0 from "./devoirsDashParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports